
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Slider } from '@/components/ui/slider';
import { Bot } from 'lucide-react';

interface ModelsTabContentProps {
  editing: boolean;
  temperature: number;
  setTemperature: (value: number) => void;
}

const ModelsTabContent: React.FC<ModelsTabContentProps> = ({ 
  editing, 
  temperature, 
  setTemperature 
}) => {
  return (
    <div className="grid gap-4">
      <div className="grid gap-2">
        <Label htmlFor="openai-api-key">OpenAI API Key</Label>
        <Input 
          id="openai-api-key" 
          placeholder="Enter your OpenAI API key" 
          type="password"
          disabled={!editing}
        />
        <p className="text-xs text-muted-foreground">
          Your API key is encrypted and stored securely
        </p>
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="default-model">Default LLM Model</Label>
        <Select disabled={!editing} defaultValue="gpt-4o">
          <SelectTrigger id="default-model">
            <SelectValue placeholder="Select a model" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="gpt-4o">GPT-4o</SelectItem>
            <SelectItem value="gpt-4o-mini">GPT-4o Mini</SelectItem>
            <SelectItem value="gpt-4.5-preview">GPT-4.5 Preview</SelectItem>
            <SelectItem value="claude-3-opus">Claude 3 Opus</SelectItem>
            <SelectItem value="claude-3-sonnet">Claude 3 Sonnet</SelectItem>
            <SelectItem value="llama-3.1-70b">Llama 3.1 (70B)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="grid gap-2">
        <div className="flex justify-between">
          <Label htmlFor="temperature-slider">Temperature ({temperature})</Label>
        </div>
        <Slider
          id="temperature-slider"
          disabled={!editing}
          min={0}
          max={1}
          step={0.1}
          value={[temperature]}
          onValueChange={values => setTemperature(values[0])}
        />
        <p className="text-xs text-muted-foreground">
          Controls randomness: Lower values are more deterministic, higher values more creative
        </p>
      </div>
    </div>
  );
};

export default ModelsTabContent;
